module.exports = __webpack_public_path__ + "static/img/ico-GooglePlay.a19b71b.svg";